import React from "react";

import TestimonialsCarousel from "./TestimonialsCarousel";

const TestimonialsSection: React.FC = () => {
  return (
    <section className="relative py-16 overflow-hidden bg-gradient-to-br from-pink-50 via-white to-purple-50">
      <div className="container px-4 mx-auto relative">
        <TestimonialsCarousel />
      </div>
    </section>
  );
};

export default TestimonialsSection;
